import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Row, Col, Button } from "react-bootstrap";
import dataServices from "../../apiServices/data.services";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import { Can } from "../../context/AuthProvider";
import { handleValidationError } from "../../components/CommonFunctions";

const AddSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const alert = useAlert();
  const navigate = useNavigate();

  useEffect(() => {
    dataServices
      .getPlans()
      .then((res) => {
        if (res.status === 200) {
          setPlans(res.data);
        }
      })
      .catch(() => {
        // ignore
      });
  }, []);

  const initialValues = {
    plan_id: "",
    start_date: "",
    end_date: "",
    status: "active",
    description: "",
  };

  const validationSchema = Yup.object().shape({
    plan_id: Yup.string().required("Plan is required"),
    start_date: Yup.string().required("Start date is required"),
    status: Yup.string().required("Status is required"),
  });

  const handleSubmit = (values) => {
    setLoading(true);
    dataServices
      .addSubscription(values)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          alert.success("Subscription created successfully");
          navigate("/subscriptions");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 fw-bold text-black">Add Subscription</h6>
      </div>
      <Can I="add" this="Subscription">
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ errors, touched }) => (
            <Form>
              <Row>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="plan_id">Plan <span className="text-danger">*</span></label>
                    <Field as="select" name="plan_id" className={`form-control ${touched.plan_id && errors.plan_id ? "is-invalid" : ""}`}>
                      <option value="">Select plan</option>
                      {plans.map((plan) => (
                        <option key={plan.id} value={plan.id}>
                          {plan.name}
                        </option>
                      ))}
                    </Field>
                    <ErrorMessage name="plan_id" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="start_date">Start Date <span className="text-danger">*</span></label>
                    <Field
                      name="start_date"
                      type="date"
                      className={`form-control ${touched.start_date && errors.start_date ? "is-invalid" : ""}`}
                    />
                    <ErrorMessage name="start_date" component="div" className="invalid-feedback" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="end_date">End Date</label>
                    <Field name="end_date" type="date" className="form-control" />
                  </div>
                </Col>
                <Col sm={6}>
                  <div className="form-group">
                    <label htmlFor="status">Status <span className="text-danger">*</span></label>
                    <Field as="select" name="status" className="form-control">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="pending">Pending</option>
                    </Field>
                  </div>
                </Col>
                <Col sm={12}>
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <Field name="description" as="textarea" rows={3} className="form-control" placeholder="Optional" />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="footer mt-auto">
                  <Button type="submit" disabled={loading} className="btn btn-primary w-100">
                    Save Subscription
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Can>
    </div>
  );
};

export default AddSubscription;
